import {fetchme} from 'gso-fetchme';
import {getEntrypoint} from 'gso-get-entrypoint';

// count = number of notifications
async function getNotifications(options, count) {
	const entrypoint = await getEntrypoint('hecate', options);
	return fetchme(
		`${entrypoint.links.notification}?action=0&count=${count}`,
		options
	);
}

async function markNotificationsAsRead(notifications, action) {
	const entrypoint = await getEntrypoint('hecate');

	return fetchme(`${entrypoint.links.notification}/archive?action=${action}`,
		 {json: notifications,
			 method: 'PATCH'}
	);
}




export {getNotifications,markNotificationsAsRead};
